import { render, staticRenderFns } from "./NothingToShow.vue?vue&type=template&id=66465538&scoped=true"
import script from "./NothingToShow.vue?vue&type=script&lang=js"
export * from "./NothingToShow.vue?vue&type=script&lang=js"
import style0 from "./NothingToShow.vue?vue&type=style&index=0&id=66465538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66465538",
  null
  
)

export default component.exports